import * as React from "react";

import {
  FeatureController,
  FeaturesProvider,
  OneTimePasswordFeatures,
  useOneTimePasswordFeatureController,
} from "../../../Common";

import { useReactJoinInitialState } from "../react-join-initial-state-provider";

export const ReactJoinFeatures = OneTimePasswordFeatures;

export const ReactJoinFeaturesProvider: React.FunctionComponent = (props) => {
  const { initialState } = useReactJoinInitialState();

  const oneTimePasswordFeatureController = useOneTimePasswordFeatureController({
    initialState,
  });

  const features: FeatureController[] = React.useMemo(
    () => [oneTimePasswordFeatureController],
    [oneTimePasswordFeatureController]
  );

  return (
    <FeaturesProvider features={features}>
      {props.children || []}
    </FeaturesProvider>
  );
};
